import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getCurrentMembership, getMembershipUsage } from '@/api/membership'

export const fetchMembership = createAsyncThunk(
  'membership/fetchCurrent',
  async () => {
    const [current, usage] = await Promise.all([
      getCurrentMembership(),
      getMembershipUsage(),
    ])
    return { current, usage }
  }
)

const membershipSlice = createSlice({
  name: 'membership',
  initialState: {
    current: null,
    usage: null,
    status: 'idle',
    error: '',
  },
  reducers: {
    resetMembership(state) {
      state.current = null
      state.usage = null
      state.status = 'idle'
      state.error = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMembership.pending, (state) => {
        state.status = 'loading'
        state.error = ''
      })
      .addCase(fetchMembership.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.current = action.payload.current
        state.usage = action.payload.usage
      })
      .addCase(fetchMembership.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error?.message || '会员状态加载失败'
      })
  },
})

export const { resetMembership } = membershipSlice.actions
export const selectMembershipReadOnly = (state) => state.membership.current?.enforcementMode === 'ENFORCE'
  && state.membership.current?.status === 'GRACE_PERIOD'
export default membershipSlice.reducer
